// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pBHuL","top":"styles_top__3YSpY","left":"styles_left__2OjKH","description":"styles_description__1HXZh"};